module.exports = __webpack_public_path__ + "static/media/GL.f2c541c3.svg";